import { createStyles, makeStyles } from "@material-ui/core";
import { useLocation } from "@reach/router";
import React from "react";
import { GuestFooter } from "./guest-footer";
import { GuestHeader } from "./guest-header";
import qs from 'query-string';

export const GuestLayout: React.FC = ({ children }) => {
    const classes = useStyles({});    
    const params = qs.parse(window.location.search || '');
    const rid = params?.rid as string|undefined;

    React.useEffect(() => {
        if (rid) {
            localStorage.setItem('rid', rid);
        }
    }, [rid]);

    return <div className={classes.page}>
        <GuestHeader />
        <main className={classes.content}>
            {children}
        </main>
        <div className={classes.footer}>
            <GuestFooter />
        </div>
    </div>
}

const useStyles = makeStyles(theme => createStyles({
    page: {
        position: 'relative',
        minHeight: '100vh',
    },
    content: {
        paddingBottom: 250,
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        height: 250,
    }
}))